import { MutationTree, GetterTree } from "vuex";

const state: any = {
  nav_title: "",
  bgColor: 'white-theme' // 0为正常模式，1为深色模式
};

const mutations: MutationTree<any> = {
  SAVE_NAV_TITLE(state, res): void {
    state.nav_title = res;
  },
  SAVE_BGCOLOR(state, res): void {
    state.bgColor = res;
  }
};

const getters: GetterTree<any, any> = {
  nav_title(state: any): void {
    return state.nav_title;
  },
  bgColor(state: any): number {
    return state.bgColor;
  }
};

export default { namespaced: true, state, mutations, getters };
